import api from 'Services/api'

const BASE_URL = `${process.env.REACT_APP_EANOTIFICACAO_URL}`
const NOVIDADES_BASE_URL = '/eanotifica/v1/mensagem/'

const novidadesApiService = {
  list() {
    return api.get(`${BASE_URL}${NOVIDADES_BASE_URL}`)
  }
}

export default novidadesApiService
